/**
 * Checks whether the given array contains the same elements,
 * regardless of the order.
 * @param  {Any[]}  arr1
 * @param  {Any[]}  arr2
 * @returns {boolean}
 */
function isEqualContentCollectionUtil (arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }
  return arr1.every(elem => arr2.includes(elem))
}

export {
  isEqualContentCollectionUtil
}
